import { CUSTOMER_JOURNEY_ATTRACTIONS_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_ATTRACTIONS_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyAttractionsSuccess.js